export default __webpack_public_path__ + "7a602cf91bc4da8acf2bc28e10edc605.png";